import type { DimensionModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import HeightModifier from "./HeightModifier";
import WidthModifier from "./WidthModifier";

interface ImageDimensionsModifierProps {
  onWidthChange: (modifiers: DimensionModifierValue[]) => void;
  onHeightChange: (modifiers: DimensionModifierValue[]) => void;
}

const ImageDimensionsModifier: React.FC<ImageDimensionsModifierProps> = ({
  onWidthChange,
  onHeightChange,
}) => {
  return (
    <div className="grid w-full grid-cols-2 gap-2">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Width</span>
        <WidthModifier onChange={onWidthChange} />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Height</span>
        <HeightModifier onChange={onHeightChange} />
      </div>
    </div>
  );
};

export default ImageDimensionsModifier;
